import { Col, Row, Input, message } from 'antd';
import { useCallback, useState } from 'react';
import { HelpdeskHttp } from '@/services';
import { AppButton, AppModal, Flex } from '../common';
import { HelpdeskMessageModalProps, HelpdeskStatus } from './helpdeskUtils';
import { useTranslation } from 'react-i18next';

export default function HelpdeskCloseModal({
  issue,
  onComplete,
  ...modalProps
}: HelpdeskMessageModalProps) {

  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [t] = useTranslation(['common', 'helpdesk']);

  const handleClose = useCallback(() => {
    setNote('');
    setLoading(false);
    modalProps.hide();
  }, [modalProps, setNote]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    try {
      await HelpdeskHttp.updateIssueNotes(issue.id, {
        issue: {
          ...(note ? { notes: note } : {}),
          status_id: HelpdeskStatus.Finished,
        },
      });
      message.success({ content: t('helpdesk:messages.success-close') });
      handleClose();
      onComplete();
    }
    catch (e) {
      message.error({ duration: 3, content: t('helpdesk:messages.fail-close') });
    }
  }, [issue, note, setLoading, onComplete, handleClose, t]);

  return (
    <AppModal
      destroyOnHidden
      title={t('helpdesk:labels.close-request')}
      onCancel={handleClose}
      variant="helpdesk"
      footer={null}
      {...modalProps}>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Flex direction="column">
            <p className="text-justify">
              {t('helpdesk:messages.close-note')}
            </p>
            <Input.TextArea
              rows={7}
              style={{ height: '100%' }}
              onChange={e => setNote(e.target.value)}
              placeholder={t('helpdesk:messages.write-close-reason')}
            />
          </Flex>
          <Flex className="mt-2" direction="column">
            <AppButton
              type="primary"
              appVariant="cancel-gray"
              loading={loading}
              onClick={handleSubmit}
              className="font-bold min-w-[6rem] mt-2 ms-auto !bg-app-gray-darker !text-white"
            >
              {t('helpdesk:labels.close-request')}
            </AppButton>
          </Flex>
        </Col>
      </Row>
    </AppModal>
  );
}
